import React, { useEffect, useState } from 'react'
import { Button, Card, Form, Modal } from 'react-bootstrap'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import { resolvePath, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { theme } from '../theme/theme'
import CustomBtn from '../common/CustomBtn'
import { BASE_URL } from '../constants'


// Function to convert number to words
const numberToWords = (num) => {
  const a = [
    '',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
  ]
  const b = [
    '',
    '',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety',
  ]

  const convertToWords = (n) => {
    if (n < 20) return a[n]
    const digit = n % 10
    if (n < 100) return b[Math.floor(n / 10)] + (digit ? '-' + a[digit] : '')
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        ' hundred' +
        (n % 100 === 0 ? '' : ' and ' + convertToWords(n % 100))
      )
    return (
      convertToWords(Math.floor(n / 1000)) +
      ' thousand ' +
      convertToWords(n % 1000)
    )
  }

  return num === 0 ? 'zero' : convertToWords(num)
}

const AddTransactionModal = ({
  show,
  handleClose,
  setHideModal,
  bookingId,
  setShowModal,
}) => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    id: bookingId || '',
    transaction_amount: '',
    transaction_amount_in_words: '',
    online_transaction_number: '',
    transaction_date: '',
    payment_method: '',
  })

  useEffect(() => {
    if (bookingId) {
      console.log('Received booking ID:', bookingId)
      setFormData((prevData) => ({ ...prevData, id: bookingId }))
    } else {
      console.log('No booking ID received.')
    }
  }, [bookingId])

  useEffect(() => {
    const token = Cookies.get('authToken')
    console.log('Checking authentication token:   ', token)
    if (!token) {
      console.log('No token found, redirecting to login')
      window.location.href = '/login'
    }
  }, [])

  const validPaymentMethod = ['CASH', 'ONLINE', 'CHEQUE']

  const inputHandler = (e) => {
    const { name, value } = e.target
    console.log(`Updating formData: ${name} = ${value}`)
    setFormData((prevData) => ({ ...prevData, [name]: value }))
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    console.log('Form submitted with data:', formData)
    if (!formData.id) {
      console.error('Booking ID is required')
      toast.error('Booking ID is missing.')
      return
    }

    const token = Cookies.get('authToken')

    console.log('Checking payment method:', formData.payment_method)
    if (!validPaymentMethod.includes(formData.payment_method)) {
      console.log('Invalid payment method selected')
      toast.error('Invalid payment method selected')
      return
    }
    if (
      (formData.payment_method === 'CHEQUE' ||
        formData.payment_method === 'ONLINE') &&
      !formData.online_transaction_number
    ) {
      toast.error(
        `Please enter ${
          formData.payment_method === 'CHEQUE'
            ? 'Cheque Number'
            : 'Transaction Number'
        }`,
      )
      return
    }

    if (formData.payment_method === 'CASH') {
      console.log('Payment method is CASH; no transaction number required.')
    }
    if (!formData.transaction_amount || !formData.transaction_date) {
      toast.error('Please enter all required fields')
      return
    }
    try {
      console.log('Sending data to the server....')
      const response = await axios.post(
        BASE_URL+'/add/transaction',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )

      console.log('Api response:', response)

      // const bookingTransaction = response.data?.booking_transaction
      // if (bookingTransaction) {
      //   console.log('Transaction successfully added:', bookingTransaction)
      //   toast.success(response.data.message)
      //   navigate('/allbooking')
      // }

      if (
        response.data.status === 409 ||
        response.data.message?.includes('Duplicate')
      ) {
        toast.error(
          response.data.message ||
            'Duplicate transaction number. Entry already exists.',
        )
        setShowPreview(false)
        setShowModal(true)
        return
      }

      const bookingTransaction = response.data?.booking_transaction
      if (bookingTransaction) {
        console.log('Transaction successfully added:', bookingTransaction)
        setShowPreview(false)

        navigate('/allbooking')
      }

      if (response.data.status === 200) {
        toast.success(response.data.message || 'Transaction added successfully')
        setShowPreview(false)

        setTimeout(() => {
          navigate('/allbooking')
          window.location.reload()
        }, 2000)
        // navigate('/allbooking')
      } else {
        toast.error('Unexpected response from server')
      }
    } catch (err) {
      const message = err?.response?.data?.message

      toast.error(message)

      setShowPreview(false)
      navigate('/allbooking')
    }
  }
  // Function to convert a number to words
  const convertNumberToWords = (num) => {
    const ones = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
    ]
    const teens = [
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ]
    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ]

    // Thousands, Lakhs, and Crores
    const thousands = ['', 'Thousand', 'Lakh', 'Crore']

    if (num === 0) return ''

    let words = ''

    // Function to convert hundreds
    const convertHundreds = (n) => {
      if (n < 10) return ones[n]
      if (n < 20) return teens[n - 10]
      if (n < 100) {
        return tens[Math.floor(n / 10)] + (n % 10 > 0 ? ' ' + ones[n % 10] : '')
      }
      return (
        ones[Math.floor(n / 100)] +
        ' Hundred' +
        (n % 100 > 0 ? ' ' + convertHundreds(n % 100) : '')
      )
    }

    // Handle Lakh and Crore
    const crore = Math.floor(num / 10000000)
    const lakh = Math.floor((num % 10000000) / 100000)
    const thousand = Math.floor((num % 100000) / 1000)
    const remainder = num % 1000

    if (crore > 0) {
      words += convertHundreds(crore) + ' Crore '
    }
    if (lakh > 0) {
      words += convertHundreds(lakh) + ' Lakh '
    }
    if (thousand > 0) {
      words += convertHundreds(thousand) + ' Thousand '
    }
    if (remainder > 0) {
      words += convertHundreds(remainder)
    }

    return words.trim() + ' Only'
  }
  // Example Usage
  const num = 340569
  const result = `${num} : ${convertNumberToWords(num)}`
  console.log(result)

  // UseEffect to update booking price in words whenever transaction_amount changes
  useEffect(() => {
    const amountInWords = convertNumberToWords(
      Number(formData.transaction_amount),
    )
    setFormData((prevBooking) => ({
      ...prevBooking,
      transaction_amount_in_words: amountInWords,
    }))
  }, [formData.transaction_amount])

  const [showPreview, setShowPreview] = useState(false)
  const togglePreview = () => {
    setShowPreview(true)
    setHideModal()
    // handleClose() // Close the main modal
  }

  const handleEditPreview = () => {
    setShowPreview(false)
    setFormData((prevData) => ({
      ...prevData, // Keep the existing form data
      transaction_amount: formData.transaction_amount,
      transaction_amount_in_words: formData.transaction_amount_in_words,
      online_transaction_number: formData.online_transaction_number,
      transaction_date: formData.transaction_date,
      payment_method: formData.payment_method,
    }))
    setShowModal(true)
  }
  return (
    <>
      <div>
        <Modal show={show} onHide={handleClose} style={{ marginTop: '6rem' }}>
          <Modal.Header closeButton closeLabel="Close" title="Close">
            <div className="w-100 text-start">
              <Modal.Title className="fw-semibold bg-light" style={{color: theme.colors.primary}}>
                Add New Transaction
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="transaction_amount">
                <Form.Label>Amount *</Form.Label>
                <Form.Control
                  type="number"
                  name="transaction_amount"
                  placeholder="Enter Transaction Amount"
                  value={formData.transaction_amount}
                  onChange={inputHandler}
                  required
                />
              </Form.Group>

              <Form.Group controlId="transaction_amount_in_words">
                <Form.Label>Transaction amount in words</Form.Label>
                <Form.Control
                  type="textarea"
                  id="transaction_amount_in_words"
                  name="transaction_amount_in_words"
                  value={formData.transaction_amount_in_words}
                  onChange={inputHandler}
                  disabled
                />
              </Form.Group>

              <Form.Group controlId="payment_method" className="mt-3">
                <Form.Label>Payment Method *</Form.Label>
                <Form.Select
                  name="payment_method"
                  value={formData.payment_method}
                  onChange={inputHandler}
                  required
                >
                  <option value="">SELECT</option>
                  <option value="ONLINE">ONLINE</option>
                  <option value="CASH">CASH</option>
                  <option value="CHEQUE">CHEQUE</option>
                </Form.Select>
              </Form.Group>

              <Form.Group
                controlId="online_transaction_number"
                className="mt-3"
              >
                <Form.Label>
                  {formData.payment_method === 'CASH'
                    ? 'Not Mandatory'
                    : formData.payment_method === 'CHEQUE'
                    ? 'Cheque Number *'
                    : 'Transaction Number *'}
                </Form.Label>

                <Form.Control
                  type="text"
                  name="online_transaction_number"
                  value={formData.online_transaction_number}
                  onChange={inputHandler}
                  placeholder={
                    formData.payment_method === 'CASH'
                      ? null
                      : formData.payment_method === 'CHEQUE'
                      ? 'Enter Cheque Number'
                      : 'Enter Transaction Number'
                  }
                  disabled={formData.payment_method === 'CASH'}
                />
              </Form.Group>

              <Form.Group controlId="transaction_date" className="mt-3">
                <Form.Label>Transaction Date *</Form.Label>
                <Form.Control
                  type="date"
                  name="transaction_date"
                  value={formData.transaction_date}
                  onChange={inputHandler}
                  required
                />
              </Form.Group>

              <div className="d-grid mt-4 mb-3">
                <CustomBtn
                
                  className="fw-semibold"
                  variant="success"
                  onClick={togglePreview}
                  style={{ letterSpacing: '1px' }}
                
                >
                  Show Preview
               
                </CustomBtn>

              </div>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal
          show={showPreview}
          onHide={() => {
            setShowPreview(false)
            handleClose()
          }}
          centered
          size="xxl"
        >
          <Modal.Header closeButton closeLabel="Close" title="Close">
            <div className="w-100 text-center">
              <Modal.Title className="fw-bold text-success bg-light">
                Transaction Preview
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="py-5">
            <p>
              <strong>Transaction Amount : </strong>
              {formData.transaction_amount}
            </p>
            <p>
              <strong>Transaction Amount in Words : </strong>
              {formData.transaction_amount_in_words}{' '}
            </p>
            <p>
              <strong>Payment Method : </strong>
              {formData.payment_method}
            </p>
            <p>
              {formData.payment_method !== 'CASH' && (
                <strong>
                  {formData.payment_method === 'CHEQUE'
                    ? 'Cheque Number'
                    : 'Online Transaction Number'}{' '}
                  :{' '}
                </strong>
              )}
              {formData.payment_method !== 'CASH' &&
                formData.online_transaction_number}
            </p>
            <p>
              <strong>Transaction Date : </strong>
              {formData.transaction_date}
            </p>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button
              className="fw-bold btn"
              style={{ width: '48%', letterSpacing: '1px' }}
              variant="secondary"
              onClick={handleEditPreview}
            >
              Edit Transaction
            </Button>

            <Button
              className="fw-bold btn"
              style={{ width: '48%', letterSpacing: '1px' }}
              variant="success"
              onClick={onSubmit}
              type="submit"
            >
              Save Transaction
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default AddTransactionModal
